export default (() => {
  class Form {
    constructor($form, ajax) {
      this.$form = $form
      this.isAjax = ajax
      this.hasFileFields = false
      this.inModal = false
      this.isSubmitting = false
    }

    init() {
      var self = this

      // Use Freeforms custom onSubmit event

      self.$form[0].addEventListener("freeform-on-submit", function (event) {
        event.preventDefault()
        return self.preprocessSubmit()
      })

      // legacy freeform events no longer supported -----
      // var freeform = Freeform.getInstance(self.$form[0])

      // if (typeof freeform !== 'undefined') {
      //   freeform.addOnSubmitCallback((formElement, options) => {
      //     return self.preprocessSubmit()
      //   })

      //   // If Freeform instance not found, set a normal onSubmit event
      // } else {
      //   self.$form.on('submit', function (e) {
      //     return self.preprocessSubmit()
      //   })
      // }

      // Live validation
      self.$form.find('.form-control').on('blur', function () {
        self.liveClientValidation($(this))
      })

      self.$form.find('.form-check-input, .custom-select').on('change', function () {
        self.liveClientValidation($(this))
      })

      // Modal
      self.inModal = self.$form.attr('data-inmodal') == '1' ? true : false
      if (self.inModal) {
        self.$form.each(function () {
          $(this)
            .closest('.modal')
            .on('show.bs.modal hidden.bs.modal', function (e) {
              self.resetForm()
              self.$form.removeClass('d-none')
            })
          $(this)
            .closest('.modal')
            .on('hide.bs.modal', function (e) {
              if (self.isSubmitting) {
                e.preventDefault()
              }
            })
        })
      }

      // websiteFormReference field population via AJAX
      if (self.$form.find('[name="websiteFormReference"]').length) {
        if (!self.inModal) {
          // Removing AJAX call because of cloudfront, using clientside value.
          self.$form.find('[name="websiteFormReference"]').val(window.document.referrer)

          // $.ajax({
          //   url: '/referrer/get',
          //   type: 'GET',
          //   dataType: 'json',
          //   cache: false,
          //   enctype: 'multipart/form-data',
          //   success: function(response) {
          //     if(response.status && response.data) {
          //       self.$form.find('[name="websiteFormReference"]').val(response.data);
          //     } else {
          //       self.$form.find('[name="websiteFormReference"]').val(window.location.href);
          //     }
          //   }
          // });
        } else {
          self.$form.find('[name="websiteFormReference"]').val(window.location.href)
        }
      }

      self.customFileFields()

      // Course query param field population
      if (self.$form[0].hasAttribute('data-ajax-populate-course')) {
        self.handleUrlParamCourseData(self.$form.attr('data-ajax-populate-course'))
      }
    }

    preprocessSubmit() {
      var self = this

      if (!self.submitClientValidation()) {
        return false
      }

      self.isSubmitting = true
      self.clearErrorsAndMessages()
      self.disableFormForSubmitting()
      if (self.isAjax) {
        self.postAjax()
        return false
      } else {
        return true
      }
    }

    postAjax() {
      var self = this

      var ajaxSettings = {
        url: self.$form.attr('data-post-url'),
        type: 'POST',
        dataType: 'json',
        data: self.$form.serialize(),
        cache: false,
        enctype: 'multipart/form-data',
        success: function (response) {
          self.isSubmitting = false
          self.handleDataLayerPush(response, self.$form.attr('data-form-name'))
          if (response.success && response.finished) {
            self.handleSuccess()
          } else {
            self.handleFormErrors(response.errors, response.formErrors)
          }
        },
        error: function (response) {
          self.isSubmitting = false
          self.handleFormErrors([])
        },
      }

      // If form has file fields, use FormData object, else use JSON (FormData not supported for < IE10).
      if (self.hasFileFields) {
        ajaxSettings.data = new FormData(self.$form[0])
        ajaxSettings.contentType = false
        ajaxSettings.processData = false
      }

      $.ajax(ajaxSettings)
    }

    liveClientValidation($field) {
      var self = this
      var errors = {}
      var $fieldWrapper = $field.closest('.field')

      Object.assign(errors, self.validateField($fieldWrapper))

      $('.invalid-feedback', $fieldWrapper).remove()

      if (Object.keys(errors).length) {
        for (var key in errors) {
          self.handleFieldError(key, errors)
        }
      } else {
        $('.is-invalid', $fieldWrapper).removeClass('is-invalid')
        $fieldWrapper.removeClass('has-error')
      }
    }

    submitClientValidation() {
      var self = this
      var valid = true
      var errors = {}

      self.$form.find('.field').each(function () {
        Object.assign(errors, self.validateField($(this)))
      })
      if (Object.keys(errors).length) {
        var valid = false
        self.handleFormErrors(errors)
      }
      return valid
    }

    validateField($fieldWrapper) {
      var self = this
      var errors = {}

      if ($fieldWrapper.is(':hidden')) {
        return {}
      }

      // Required fields
      if ($fieldWrapper.hasClass('required')) {
        var $textInputs = $fieldWrapper.find('input[type="text"], input[type="file"], select, textarea')
        $textInputs.each(function () {
          if ($(this).val() == '') {
            var errorMessage = 'Please fill out this field'
            if ($(this).data('validation') !== undefined) {
              errorMessage = $(this).data('validation')
            }
            errors[$(this).prop('name').replace('[]', '')] = [errorMessage]
          }
        })
        var $selectInputs = $fieldWrapper.find('select')
        $selectInputs.each(function () {
          if ($(this).val() == '') {
            var errorMessage = 'Please select an option'
            if ($(this).data('validation') !== undefined) {
              errorMessage = $(this).data('validation')
            }
            errors[$(this).prop('name').replace('[]', '')] = [errorMessage]
          }
        })
        var $radios = $fieldWrapper.find('input[type="radio"]')
        if ($radios.length) {
          if (!$fieldWrapper.find('input[type="radio"]:checked').length) {
            var errorMessage = 'Please select an option'
            if ($fieldWrapper.find('input[type="radio"]').eq(0).data('validation') !== undefined) {
              errorMessage = $fieldWrapper.find('input[type="radio"]').eq(0).data('validation')
            }
            errors[$fieldWrapper.find('input[type="radio"]').eq(0).prop('name').replace('[]', '')] = [errorMessage]
          }
        }
        var $checkboxes = $fieldWrapper.find('input[type="checkbox"]')
        if ($checkboxes.length) {
          if (!$fieldWrapper.find('input[type="checkbox"]:checked').length) {
            var errorMessage = 'Please select an option'
            if ($fieldWrapper.find('input[type="checkbox"]').eq(0).data('validation') !== undefined) {
              errorMessage = $fieldWrapper.find('input[type="checkbox"]').eq(0).data('validation')
            }
            errors[$fieldWrapper.find('input[type="checkbox"]').eq(0).prop('name').replace('[]', '')] = [errorMessage]
          }
        }
      }

      // Email formatting
      var $textInputs = $fieldWrapper.find('input[type="email"]')
      $textInputs.each(function () {
        if (($fieldWrapper.hasClass('required') && $(this).val() == '') || ($(this).val() != '' && !self.validateEmail($(this).val()))) {
          var errorMessage = 'Please provide a valid email address'
          errors[$(this).prop('name').replace('[]', '')] = [errorMessage]
        }
      })

      // Phone formatting
      var $textInputs = $fieldWrapper.find('input[type="tel"]')
      $textInputs.each(function () {
        if (($fieldWrapper.hasClass('required') && $(this).val() == '') || ($(this).val() != '' && !self.validatePhone($(this).val()))) {
          var errorMessage = 'Please provide a valid phone number'
          errors[$(this).prop('name').replace('[]', '')] = [errorMessage]
        }
      })

      // Confirm field matching
      var $confirmInputs = $fieldWrapper.find('input[data-confirm-target]')
      $confirmInputs.each(function () {
        var $confirmInput = $(this)
        var $targetFields = self.$form.find('[data-field-hash="' + $(this).data('confirm-target') + '"]')
        $targetFields.each(function () {
          if ($(this).val() != '' && $(this).val() != $confirmInput.val()) {
            var errorMessage = 'Please ensure that you confirm this field correctly'
            errors[$confirmInput.prop('name').replace('[]', '')] = [errorMessage]
          }
        })
      })
      return errors
    }

    handleFormErrors(errors, formErrors) {
      var self = this
      var formMessage = formErrors && formErrors.length ? formErrors.join('<br />') : 'Please ensure that all mandatory fields have been filled.'

      self.clearErrorsAndMessages()
      self.generateFormMessage('danger', formMessage)

      for (var key in errors) {
        self.handleFieldError(key, errors)
      }

      var $firstError = $('.is-invalid', self.$form).eq(0)
      if ($firstError.length) {
        $firstError.focus()
        var offset = self.calculateCentreScreenOffset($firstError)
      } else {
        var offset = self.calculateCentreScreenOffset(self.$form)
      }
      self.scrollForm(offset)
    }

    handleFieldError(key, errors) {
      var self = this

      if (!errors.hasOwnProperty(key)) {
        return
      }

      var messages = errors[key]
      var $errors = false

      if (messages.length) {
        $errors = $('<div>', { class: 'invalid-feedback' }).append(messages[0])
      }

      var $input = self.$form.find('*[name=' + key + "], *[name='" + key + "[]']", self.$form)
      $input.addClass('is-invalid')

      var $fieldWrapper = $input.parents('.form-group')
      if (!$fieldWrapper.length) {
        $fieldWrapper = $input.closest('div')
      }
      $fieldWrapper.addClass('has-error')

      if ($errors) {
        $fieldWrapper.append($errors)
      }
    }

    handleSuccess() {
      var self = this
      var returnUrl = self.$form.attr('data-return-url')

      if (returnUrl) {
        var r = new RegExp('^(?:[a-z]+:)?//', 'i')
        if (!r.test(returnUrl)) {
          returnUrl = window.location.protocol + '//' + window.location.host + returnUrl
        }
        window.location = returnUrl
      } else {
        self.$form.addClass('d-none')
        self.resetForm()
        self.generateFormMessage('success', 'Submission successful.')
      }
    }

    generateFormMessage(type, msg) {
      var self = this
      var $messageAlert = $('<div>', { class: 'alert alert-' + type }).append(msg)
      var $successBlock = self.$form.prev('.success-message')

      if (type == 'success') {
        $successBlock.removeClass('d-none')
        var offset = self.calculateCentreScreenOffset($successBlock)
        self.scrollForm(offset)
      } else {
        $successBlock.addClass('d-none')
        self.$form.prepend($messageAlert)
      }
    }

    clearErrorsAndMessages() {
      var self = this

      $('.alert', self.$form).remove()
      $('.invalid-feedback', self.$form).remove()
      $('.has-error', self.$form).removeClass('has-error')
      $('.is-invalid', self.$form).removeClass('is-invalid')
      self.$form.prev('.success-message').addClass('d-none')

      self.enableForm()
    }

    disableFormForSubmitting() {
      var self = this

      $('.form-control', self.$form).each(function () {
        $(this).attr('readonly', 'readonly')
      })

      var $submitButton = $('button[type=submit]', self.$form)
      $submitButton.attr('data-text', $submitButton.text())
      $submitButton.attr('disabled', true).text(' Please wait …')
      $submitButton.prepend('<span class="spinner-btn" role="status" aria-hidden="true"></span>')

      if (!self.inModal) {
        var offset = self.calculateCentreScreenOffset($submitButton)
        self.scrollForm(offset)
      }
    }

    enableForm() {
      var self = this

      $('.form-control', self.$form).each(function () {
        $(this).removeAttr('readonly')
      })

      var $submitButton = $('button[type=submit]', self.$form)
      $submitButton.prop('disabled', false).text($submitButton.attr('data-text'))
      $submitButton.remove('.spinner-btn')
    }

    resetForm() {
      var self = this

      self.$form[0].reset()
      self.$form.find('.custom-file-label').html('Upload a file')
      self.clearErrorsAndMessages()
    }

    scrollForm(offset) {
      var self = this

      if (self.inModal) {
        self.$form.closest('.modal').animate({ scrollTop: offset })
      } else {
        $('html, body').animate({ scrollTop: offset })
      }
    }

    customFileFields() {
      var self = this

      if (self.$form.find('input[type="file"]').length) {
        self.hasFileFields = true
      }
      self.$form.find('input[type="file"]').on('change', function () {
        var files = []
        for (var i = 0; i < $(this)[0].files.length; i++) {
          files.push($(this)[0].files[i].name)
        }
        $(this).next('.custom-file-label').html(files.join(', '))
      })
      self.$form.find('.file-field-reset').on('click', function () {
        $(this).parent().find('input[type="file"]').val('')
        $(this).parent().find('.custom-file-label').html('Upload a file')
        return false
      })
    }

    handleDataLayerPush(response, formName) {
      if (response.success && !response.finished) {
        return
      }

      var customValues = {
        status: response.success ? 'success' : 'invalid',
        formName: formName,
      }

      if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
          event: 'custom.form.submit',
          custom: customValues,
        })
      }
    }

    calculateCentreScreenOffset(el) {
      var elOffset = el.offset().top
      var elHeight = el.height()
      var windowHeight = $(window).height()
      var offset

      if (elHeight < windowHeight) {
        return elOffset - (windowHeight / 2 - elHeight / 2)
      } else {
        return elOffset
      }
    }

    validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    }

    validatePhone(phone) {
      var re = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g
      return re.test(String(phone))
    }

    handleUrlParamCourseData(courseCode) {
      var self = this

      if (!courseCode) {
        self.handleUrlParamCourseDataError('No course found! Please try again by applying directly via one of our <a href="/courses">course</a> pages.')
        return
      }

      $.ajax({
        url: '/api/course',
        type: 'POST',
        dataType: 'json',
        data: {
          'course-code': courseCode,
        },
        cache: false,
        enctype: 'multipart/form-data',
        success: function (response) {
          if (response.status === true && response.data.hasOwnProperty('courseCode')) {
            self.handleUrlParamCourseDataSuccess(response.data)
          } else if (response.status === true) {
            self.handleUrlParamCourseDataError('No course found! Please try again by applying directly via one of our <a href="/courses">course</a> pages.')
          } else {
            self.handleUrlParamCourseDataError('There was an error loading this form. Please try again or contact us directly.')
          }
        },
        error: function (response) {
          self.handleUrlParamCourseDataError('There was an error loading this form. Please try again or contact us directly.')
        },
      })
    }

    handleUrlParamCourseDataSuccess(data) {
      var self = this
      self.$form.parent().find('.form-ajax-loader').remove()
      self.$form.addClass('loaded')

      self.$form.find('[name="courseCode"]').val(data.courseCode)
      self.$form.find('[name="courseName"]').val(data.title)
      self.$form.find('[name="courseDepartment"]').val(data.department)
      self.$form.find('[name="fullFee"]').val(data.fullFee)

      if (data.hasOwnProperty('enquiryType')) {
        self.$form.find('[name="enquiryType"]').val(data.enquiryType)
      }

      self.$form.find('[data-course-populate]').html(`
        <span class="lead">Course code:</span> ${data.courseCode}<br />
        <span class="lead">Course name:</span> ${data.title}<br />
        <span class="lead">Full fee:</span> $${data.fullFee}
      `)

      let sessionRadios = ''
      let index = 0
      let $preferredAvailabilityEl = self.$form.find('[name="preferredAvailability"]')
      let isRequired = $preferredAvailabilityEl[0].hasAttribute('data-required')
      if (data.hasOwnProperty('sessions')) {
        for (const session of data.sessions) {
          sessionRadios += `
            <div class="form-check custom-control custom-radio pb-2">
              <input type="radio" name="${$preferredAvailabilityEl.attr('name')}" value="${session.keyId}~${session.description}" id="${$preferredAvailabilityEl.attr('id')}-${index}" class="form-check-input custom-control-input">
              <label class="form-check-label custom-control-label" for="${$preferredAvailabilityEl.attr('id')}-${index}">
                <span class="font-weight-semi">${session.campus}</span><br />
                ${session.description}
              </label>
            </div>
          `
          index++
        }
      } else {
        sessionRadios = '<p>Sorry, there are no sessions available for this course at the moment.</p>'
      }

      $preferredAvailabilityEl.parent().attr({ class: `field field-radio-group ${isRequired ? 'required' : ''} form-group col-lg-12 col-12` })
      $preferredAvailabilityEl.replaceWith(sessionRadios)
    }

    handleUrlParamCourseDataError(msg) {
      var self = this
      self.$form.parent().find('.form-ajax-loader').remove()
      self.$form.parent().prepend(`<p>${msg}</p>`)
    }
  }

  // Process all <form> on page
  $('form').each(function () {
    if ($(this)[0].hasAttribute('data-ajax-form')) {
      var ajaxForm = new Form($(this), true)
      ajaxForm.init()
    } else if ($(this)[0].hasAttribute('data-nonajax-form')) {
      var form = new Form($(this), false)
      form.init()
    }
  })
})()

// Overwrite Freeform validation functions
window.renderFormSuccess = function () {}
window.removeMessages = function () {}
window.renderErrors = function () {}
window.renderFormErrors = function () {}
